import React, { FC, useState } from "react";
import NavPills from "../../shared/components/NavPills";
import AdminParentAccountsGrid from "./AdminParentAccountsGrid";
import AdminFundRaisersGrid from "./AdminFundRaisersGrid";

const TABS = {
  merchantAccounts: "merchantAccounts",
  fundRaisers: "fundRaisers",
};

const AdminMain: FC = () => {
  const [activeTab, setActiveTab] = useState<string>(TABS.merchantAccounts);

  return (
    <div>
      <div style={{ padding: "20px 20px 0" }}>
        <NavPills
          defaultActiveKey={TABS.merchantAccounts}
          activeKey={activeTab}
          onSelect={(key) => setActiveTab(key)}
          pills={[
            { key: TABS.merchantAccounts, title: "MERCHANT ACCOUNTS" },
            { key: TABS.fundRaisers, title: "FUND RAISERS" },
          ]}
        />
      </div>
      {activeTab === TABS.merchantAccounts && <AdminParentAccountsGrid />}
      {activeTab === TABS.fundRaisers && <AdminFundRaisersGrid />}
    </div>
  );
};

export default AdminMain;
